import type { Invoice } from '@riverpark/types'

function round2dp(value: number): number {
  return Math.round(value * 100) / 100
}

/** Credit still left to use — nothing for a voided credit note. */
export function creditLeft(credit: Invoice): number {
  if (credit.status === 'voided') return 0
  return Math.max(0, round2dp(Math.abs(credit.amount) - credit.amountPaid))
}

export function formatBillingPeriod(period?: string): string {
  if (!period) return ''
  const [year, month] = period.split('-')
  if (!month) return year ?? ''
  return new Date(Date.UTC(Number(year), Number(month) - 1, 1)).toLocaleDateString('en-KE', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

/** What the credit is for, in plain words — names the bill it corrects where there is one. */
export function creditReason(credit: Invoice): string {
  const related = credit.relatedInvoice
  if (!related) return credit.description
  if (related.status === 'voided') {
    return `Credit returned from cancelled bill ${related.invoiceNumber}`
  }
  const what = related.utilityTypeName ? `${related.utilityTypeName} bill` : 'bill'
  const period = formatBillingPeriod(related.billingPeriod)
  return `Correction to ${what} ${related.invoiceNumber}${period ? ` (${period})` : ''}`
}
